import axios from "axios";
import API from "./api";

export const AUTH_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5300/api";

function storeSession(data: any) {
  if (data?.accessToken) localStorage.setItem("accessToken", data.accessToken);
  if (data?.refreshToken) localStorage.setItem("refreshToken", data.refreshToken);
  if (data?.expiresIn) {
    localStorage.setItem("tokenExpiresAt", String(Date.now() + data.expiresIn * 1000));
  }
  if (Array.isArray(data?.roles)) {
    localStorage.setItem("roles", JSON.stringify(data.roles));
  }
}

// const AuthService = {
//   demanderCode: async (email: string) => {
//     const response = await API.post("/auth/login/demande", { email });
//     return response.data.donnees;
//   },

//   validerCode: async (email: string, code: string) => {
//     const response = await API.post("/auth/login/valider", { email, code });
//     const data = response.data.donnees;

//     storeSession(data);

//     return data;
//   },

//   // Appel direct (sans l'intercepteur API) pour éviter la boucle infinie
//   refresh: async (refreshToken: string) => {
//     const response = await axios.post(`${AUTH_BASE_URL}/auth/refresh`, { refreshToken });
//     const data = response.data.donnees;

//     storeSession(data);

//     return data;
//   },

//   me: async () => {
//     const response = await API.get("/auth/me");
//     return response.data.donnees;
//   },

//   logout: () => {
//     localStorage.removeItem("accessToken");
//     localStorage.removeItem("refreshToken");
//     localStorage.removeItem("tokenExpiresAt");
//   },
// };

const AuthService = {
  demanderCode: async (email: string) => {
    const response = await API.post("/auth/login/demande", { email });
    return response.data.donnees;
  },

  validerCode: async (email: string, code: string) => {
    const response = await API.post("/auth/login/valider", { email, code });
    const data = response.data.donnees;

    storeSession(data);

    return data;
  },

  refresh: async (refreshToken: string) => {
    const response = await axios.post(
      `${AUTH_BASE_URL}/auth/refresh`,
      { refreshToken }
    );

    const data = response.data.donnees;

    storeSession(data);

    return data;
  },

  me: async () => {
    const response = await API.get("/auth/me");
    return response.data.donnees;
  },

  hasRole: (role: string): boolean => {
    const rolesString = localStorage.getItem("roles");

    if (!rolesString) {
      return false;
    }

    try {
      const roles = JSON.parse(rolesString);

      return Array.isArray(roles) && roles.includes(role);
    } catch (error) {
      console.error("Erreur lecture des rôles :", error);
      return false;
    }
  },

  logout: () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("tokenExpiresAt");
    localStorage.removeItem("roles");
  },
}
export default AuthService;
